<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div>
    <div class="row">
        <div class="col-md-4">
            <span class="hipster img-fluid img-rounded"></span>
        </div>
        <div class="col-md-8">
            <h1>{{ 'error.title' | translate }}</h1>

            <div [hidden]="!errorMessage">
                <div class="alert alert-danger">{{ errorMessage }}</div>
            </div>
            <div [hidden]="!error403" class="alert alert-danger">{{ 'error.403' | translate }}</div>
        </div>
    </div>
</div>
